export const ws_notify = {
  notify: function(msg){
    if(this.$store.getters.debug){
      console.log("notify: " + JSON.stringify(msg));
    }
    if("eid" in msg){
      var message = {
        type: "error",
        message: msg
      };
      if(["001", "002", "101"].indexOf(msg.eid.split(":")[0].slice(-3)) >= 0
        && "jid" in msg.param){
        if(this.$store.getters.preference
          && this.$store.getters.preference.web_socket_job_type){
          if(this.$store.getters.preference.web_socket_job_type.indexOf(msg.param.type) < 0){
            return;
          }
        }else{
          if(["translate", "estimate", "train", "corpus_import", "term_import", "similarity"].indexOf(msg.param.type) < 0){
            return;
          }
        }
        message.route = "/job/" + msg.param.jid;
      }
      this.$store.commit("setNotification", message);
    }
  }
}
